function getRelevantOptions(options: number[]) {
  const converted = options.map((number) => ({
    label: `${number}`,
    value: `${number}`,
  }));

  return converted;
}

export function updateOptions({
  options,
  originalPageSize,
}: {
  options: number[];
  originalPageSize: number;
}) {
  if (options.includes(originalPageSize) || !Number(originalPageSize)) {
    return getRelevantOptions(options);
  }
  const updated = [...options, Number(originalPageSize)].sort((a, b) => a - b);
  return getRelevantOptions(updated);
}

export default updateOptions;
